import styled from 'styled-components';

export const EmptyProfileTextWrapper = styled.div`
  margin: 35px auto 0 auto;
  width: 220px;
  text-align: center;
`;
